module.exports = __webpack_public_path__ + "img/LandingPage-icon.77f9468c.svg";